"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classname = _interopRequireDefault(require("./classname"));
var _hooks = require("./hooks");
/* eslint-disable jsx-a11y/click-events-have-key-events */

const getClass = (normalClass, activeClass, isActive) => {
  return isActive ? "".concat(normalClass, " ").concat(activeClass) : normalClass;
};
const Modal = _ref => {
  let {
    state,
    placeholderRef,
    close,
    closeButton,
    children,
    padding
  } = _ref;
  const classes = (0, _classname.default)();
  const bodyPadding = !padding ? " ".concat(classes.noBodyPadding) : '';
  return /*#__PURE__*/_react.default.createElement("div", {
    className: getClass(classes.container, classes.containerActive, state === _hooks.STATE.IS_IN_PROGRESS || state === _hooks.STATE.IS_OPEN)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: getClass(classes.body, classes.bodyActive, _hooks.STATE.IS_OPEN === state) + bodyPadding
  }, children), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.placeholder,
    ref: placeholderRef
  }), closeButton &&
  /*#__PURE__*/
  // eslint-disable-next-line jsx-a11y/no-static-element-interactions
  _react.default.createElement("div", {
    className: getClass(classes.closeButton, _hooks.STATE.IS_OPEN === state),
    onClick: close
  }));
};
Modal.defaultProps = {
  closeButton: true,
  padding: true
};
var _default = exports.default = Modal;